/* ORLO editorial enhancement only. No cart, discount, or checkout handlers. */
(() => {
  if (window.mifoaOrloContent) {
    window.mifoaOrloContent.init(document);
    return;
  }

  const mounts = new Map();
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mountComparison(root) {
    if (mounts.has(root)) return;
    const controls = root.querySelector('[data-orlo-comparison-controls]');
    const panels = [...root.querySelectorAll('[data-orlo-comparison-panel]')];
    const buttons = [...root.querySelectorAll('[data-orlo-comparison-tab]')];
    const stage = root.querySelector('[data-orlo-comparison-panels]');
    if (!controls || panels.length !== 2 || buttons.length !== 2 || !stage) return;
    let selected = root.dataset.orloDefaultState || 'dressed';

    const sync = () => {
      const reduced = prefersReducedMotion.matches;
      controls.hidden = reduced;
      stage.classList.toggle('is-enhanced', !reduced);
      panels.forEach((panel) => {
        panel.hidden = !reduced && panel.dataset.orloComparisonPanel !== selected;
        if (reduced) {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        } else {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', panel.dataset.orloTabId);
          panel.setAttribute('tabindex', '0');
        }
      });
      buttons.forEach((button) => {
        const active = button.dataset.orloComparisonTab === selected;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
    };

    const click = (event) => {
      const button = event.target.closest('[data-orlo-comparison-tab]');
      if (!button || !controls.contains(button)) return;
      selected = button.dataset.orloComparisonTab;
      sync();
    };

    const keydown = (event) => {
      const index = buttons.indexOf(event.target);
      if (index < 0) return;
      let next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = buttons.length - 1;
      else return;
      event.preventDefault();
      selected = buttons[next].dataset.orloComparisonTab;
      sync();
      buttons[next].focus();
    };

    controls.addEventListener('click', click);
    controls.addEventListener('keydown', keydown);
    prefersReducedMotion.addEventListener?.('change', sync);
    mounts.set(root, () => {
      controls.removeEventListener('click', click);
      controls.removeEventListener('keydown', keydown);
      prefersReducedMotion.removeEventListener?.('change', sync);
    });
    sync();
  }

  function init(scope = document) {
    if (scope.matches?.('[data-orlo-comparison]')) mountComparison(scope);
    scope.querySelectorAll?.('[data-orlo-comparison]').forEach(mountComparison);
  }

  function syncVariant(variant) {
    if (!variant?.id) return;
    const id = String(variant.id);
    document.querySelectorAll('.mf-orlo-finishes [data-orlo-select-variant]').forEach((button) => {
      const selected = button.dataset.variantId === id;
      button.setAttribute('aria-pressed', String(selected));
      button.classList.toggle('is-selected', selected);
      const state = button.querySelector('[data-orlo-selected-state]');
      if (state && !button.disabled) state.textContent = selected ? button.dataset.selectedLabel : button.dataset.selectLabel;
    });
  }

  window.mifoaOrloContent = { init, syncVariant };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, cleanup] of mounts) {
      if (root === event.target || event.target.contains(root)) {
        cleanup();
        mounts.delete(root);
      }
    }
  });
  document.addEventListener('orlo:variant-change', (event) => syncVariant(event.detail?.variant));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
